module.exports = __webpack_public_path__ + "static/img/intro-pic1@3x.ebd05e48.jpg";